import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { parseUrlParams } from 'utils/parseUrlParams';
import {
  newCheckInAction,
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';
import ContentWrapper from '../../components/ContentWrapper';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Card from '../../components/Card';
import Footer from '../../components/Footer';
import Pagination from '../../components/Pagination';
import Tooltip from '../../components/Tooltip';
import Button from '../../components/Button';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import ListView from '../../components/ListView';
import Headline from '../../components/Headline';

import FullLogo from '../../assets/images/logo-full.svg';

const image = null;

function IDALanding(props) {
  const config = useConfig();
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(null);
  const { checkinData } = props;

  useEffect(() => {
    const { dispatch } = props;
    const params = parseUrlParams(window.location.search);

    if (params.test) {
      const data = params.to
        ? {
          test: params.test,
          to: params.to,
        }
        : {
          test: params.test,
        };
      dispatch(newCheckInAction({
        key: params.key || '',
        workflowType: 'ida',
        data,
      }));
    } else {
      const data = params.to
        ? {
          to: params.to,
        }
        : {
        };
      dispatch(newCheckInAction({
        key: params.key || '',
        workflowType: 'ida',
        data,
      }));
    }
  }, []);

  useEffect(() => {
    const { fetch, navigate } = props;

    if (checkinData.activity) {
      // extract route url from the api response
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [checkinData]);

  const handleNavigation = (e) => {
    e.preventDefault();
    const { dispatch } = props;
    const params = parseUrlParams(window.location.search);

    setIsProgressVisible(true);

    if (params.test) {
      dispatch(newNextAction({
        key: params.key,
        workflowType: 'ida',
        data: {
          test: params.test,
        },
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    } else {
      dispatch(newNextAction({
        key: params.key,
        workflowType: 'ida',
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    }
  };

  const renderHeader = () => (
    <ContentWrapper>
      <Headline
        image={FullLogo}
        header={(
          <>
            <span>
              Hi
              {' '}
              {
                // eslint-disable-next-line react/destructuring-assignment
                props.checkinData.data.data.applicant.firstName
              }
              !
            </span>
            Apply in
            {' '}
            <u>minutes</u>
            <br />
            Decisions in
            {' '}
            <u>seconds</u>
            .
            <br />
            Check your rate.
            <Tooltip>To check the rates you qualify for, LendingUSA does a soft credit pull that will not impact your credit score.</Tooltip>
          </>
        )}
      />
    </ContentWrapper>
  );

  const { checkinData: { activity, attributes, data } } = props || {};

  return (
    activity === 'ApplyNow'
      ? (
        <Transition className="transition-item wrapper landing">
          {renderHeader()}
          <Footer>
            <FormRow>
              <FormColumn>
                <p className="appId mb-1" style={{ color: '#FFF' }}>
                  <b>Application ID:</b>
                  {' '}
                  {get(attributes, 'entityId')}
                </p>
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <Card title="Your Provider">
                  <ListView
                    data={[
                      <strong>{data.data && data.data.provider.name}</strong>,
                      data.data.provider.streetAddress,
                      `${data.data.provider.city}, ${data.data.provider.state} ${data.data.provider.zip}`,
                    ]}
                  />
                </Card>
                {
              image
                && <img src={image} alt="imagetag" />
              }
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <Button
                  className="btn btn-primary arrow"
                  onClick={handleNavigation}
                  title="Apply Now"
                />
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <Pagination activeIndex={0} />
              </FormColumn>
            </FormRow>
          </Footer>
          {
          isProgressVisible && <Progress percent={uploadingPercentage} />
        }
        </Transition>
      )
      : ''
  );
}

IDALanding.propTypes = {
  dispatch: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(IDALanding);
